// import React, { useState, useMemo, useEffect } from "react";
// // @ts-ignore
// import styles from "./UserList.module.css";
// import Table from "./Table/Table";
// import usersData from "../../DummyData/Customers/UserList";
// import Sidebar from "../../../../CommonComponets/SideBar";
// // import BusinessAddCustomer from "../../Pages/CustomerArea/AddCustomer/AddCustomer";
// const BusinessAddCustomer = React.lazy(
//   () => import("../../Pages/CustomerArea/AddCustomer/AddCustomer"),
// );
// const PromoteAsAssociate = React.lazy(
//   () =>
//     import("../../../AssociatePanel/Pages/CustomerArea/PromoteAsAssociate/PromoteAsAssociate"),
// );

// import { MdAddCircleOutline, MdClose, MdFilterListOff } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import useApiRequest from "../../../../Hooks/apiReq";

// const UserList = () => {
//   const [activeTab, setActiveTab] = useState("All");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedRole, setSelectedRole] = useState("All");
//   const [isCustomerAdd, setIsCustomer] = useState(false);
//   const [promoteAsAssociate, setpromoteAsAssociate] = useState(false);
//   const [recentCustomers, setRecentCustomers] = useState([]);
//   const [selfCustomerData, setSelfCustomerData] = useState([]);
//   const [firstCallDataSelf, setFirstCallDataSelf] = useState([]);
//   const [Sloading, setSloading] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const { sendApiRequest: SsendApiRequest } = useApiRequest();
//   // --- Helper: Date Formatting Logic ---
//   const getDaysAgo = (days: number) => {
//     const date = new Date();
//     date.setDate(date.getDate() - days);
//     return date;
//   };

//   const parseDate = (str: string) => {
//     const [day, month, year] = str.split("-");
//     return new Date(Number(year), Number(month) - 1, Number(day));
//   };

//   // --- Logic: Clear All Filters ---
//   const handleClearAll = () => {
//     setActiveTab("All");
//     setSearchTerm("");
//     setSelectedRole("All");
//   };

//   const isFilterActive =
//     activeTab !== "All" || searchTerm !== "" || selectedRole !== "All";

//   // --- Logic: Dynamic Filtering ---
//   const filteredUsers = useMemo(() => {
//     return usersData.filter((user) => {
//       // 1. Tab Filtering
//       const userDate = parseDate(user.CreatedOn);
//       if (activeTab === "Active" && user.Status !== "Y") return false;
//       if (activeTab === "KYC Pending" && user.KYCStatus !== "N") return false;
//       if (activeTab === "Last 15 Days" && userDate < getDaysAgo(15))
//         return false;
//       if (activeTab === "Last 30 Days" && userDate < getDaysAgo(30))
//         return false;

//       // 2. Role Filtering
//       if (selectedRole !== "All" && user.CustomerType !== selectedRole)
//         return false;

//       // 3. Search Filtering
//       const searchLower = searchTerm.toLowerCase();
//       const matchesSearch =
//         user.CustomerName.toLowerCase().includes(searchLower) ||
//         user.PrimaryMobile.includes(searchTerm) ||
//         user.EmailID.toLowerCase().includes(searchLower);

//       return matchesSearch;
//     });
//   }, [activeTab, searchTerm, selectedRole]);

//   // --- Logic: Dynamic Tab Counts ---
//   const tabs = [
//     { label: "All", count: usersData.length, color: "#3b82f6" },
//     {
//       label: "Active",
//       count: usersData.filter((u) => u.Status === "Y").length,
//       color: "#e6f4ea",
//     },
//     {
//       label: "KYC Pending",
//       count: usersData.filter((u) => u.KYCStatus === "N").length,
//       color: "#fff7e6",
//     },
//     {
//       label: "Last 15 Days",
//       count: usersData.filter((u) => parseDate(u.CreatedOn) >= getDaysAgo(15))
//         .length,
//       color: "#fce8e6",
//     },
//     {
//       label: "Last 30 Days",
//       count: usersData.filter((u) => parseDate(u.CreatedOn) >= getDaysAgo(30))
//         .length,
//       color: "#f1f3f4",
//     },
//   ];
//   useEffect(() => {
//     setLoading(true);
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [filteredUsers]);

//   const getSelfCustomerList = () => {
//     if (Sloading) {
//       return;
//     }
//     const data = {
//       Mode: "SELECT",
//       Status: "",
//       Filter: "",
//       SearchKey: "",
//       CustomerType: "Y",
//     };
//     SsendApiRequest(
//       "POST",
//       "/CustomerArea/GetCustomerList",
//       { ...data },
//       {
//         onSuccess: (res: any) => {
//           console.log(res);
//           const ParsedData = res?.data?.jsondata
//             ? JSON.parse(res?.data?.jsondata)
//             : [];
//           setSelfCustomerData(ParsedData);
//         },
//         onStatus3: () => {
//           navigate("/login");
//         },
//       },
//     );
//   };
//   useEffect(() => {
//     getSelfCustomerList();
//   }, []);

//   return (
//     <div className={styles.container}>
//       <header className={styles.header}>
//         <div className={styles.titleArea}>
//           <h1>Customer List</h1>
//           <p className={styles.subTitle}>
//             Manage and monitor your customer base
//           </p>
//         </div>
//         <button
//           className={styles.addButton}
//           onClick={() => setIsCustomer(true)}
//         >
//           <MdAddCircleOutline className={styles.btnIcon} />
//           Add Customer
//         </button>
//       </header>

//       {/* Sidebar for Add Customer */}

//       {isCustomerAdd && (
//         <Sidebar
//           setIsFilter={() => setIsCustomer((prev) => !prev)}
//           heading="Add New Customer"
//           subHeading="Build a strong foundation for your business success"
//         >
//           <BusinessAddCustomer />
//         </Sidebar>
//       )}

//       {/* Sidebar for Promote As Associate */}
//       {/*  @ts-ignore */}
//       {promoteAsAssociate && (
//         <Sidebar setIsFilter={() => setpromoteAsAssociate((prev) => !prev)}>
//           <PromoteAsAssociate />
//         </Sidebar>
//       )}

//       {/* Tabs Section */}
//       <div className={styles.tabsContainer}>
//         {tabs.map((tab) => (
//           <button
//             key={tab.label}
//             className={`${styles.tab} ${activeTab === tab.label ? styles.activeTab : ""}`}
//             style={
//               activeTab === tab.label ? { borderBottomColor: tab.color } : {}
//             }
//             onClick={() => setActiveTab(tab.label)}
//           >
//             {tab.label} <span className={styles.count}>{tab.count}</span>
//           </button>
//         ))}
//       </div>

//       {/* Filters Section */}
//       <div className={styles.filterBar}>
//         <div className={styles.filterInputs}>
//           <div className={styles.selectGroup}>
//             <select
//               className={styles.select}
//               value={selectedRole}
//               onChange={(e) => setSelectedRole(e.target.value)}
//             >
//               <option value="All">All Customer</option>
//               <option value="Y">Self Customer</option>
//               <option value="N">Referal Customer</option>
//             </select>
//           </div>

//           <div className={styles.searchWrapper}>
//             <input
//               type="text"
//               placeholder="Search by name, phone or email..."
//               className={styles.searchInput}
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>
//         </div>
//       </div>

//       {/* Active Filter Chips */}
//       {isFilterActive && (
//         <div className={styles.chipsContainer}>
//           {activeTab !== "All" && (
//             <div className={styles.chip}>
//               Tab: {activeTab}
//               <MdClose
//                 className={styles.closeIcon}
//                 onClick={() => setActiveTab("All")}
//               />
//             </div>
//           )}
//           {selectedRole !== "All" && (
//             <div className={styles.chip}>
//               Type: {selectedRole}
//               <MdClose
//                 className={styles.closeIcon}
//                 onClick={() => setSelectedRole("All")}
//               />
//             </div>
//           )}

//           {searchTerm && (
//             <div className={styles.chip}>
//               Search: "{searchTerm}"
//               <MdClose
//                 className={styles.closeIcon}
//                 onClick={() => setSearchTerm("")}
//               />
//             </div>
//           )}

//           {isFilterActive && (
//             <div
//               className={`${styles.chip} ${styles.clearAllBtn}`}
//               onClick={handleClearAll}
//             >
//               <MdFilterListOff /> Clear All
//             </div>
//           )}
//         </div>
//       )}

//       {/* Table Section */}
//       <Table
//         users={filteredUsers}
//         loading={loading}
//         handlePromoteAsAssociate={() => setpromoteAsAssociate(true)}
//       />
//     </div>
//   );
// };

// export default UserList;

import React, { useState, useEffect, useCallback } from "react";
// @ts-ignore
import styles from "./UserList.module.css";
import Table from "./Table/Table";
import Sidebar from "../../../../CommonComponets/SideBar";
import { MdAddCircleOutline, MdClose, MdFilterListOff } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import useApiRequest from "../../../../Hooks/apiReq";

const BusinessAddCustomer = React.lazy(
  () => import("../../Pages/CustomerArea/AddCustomer/AddCustomer"),
);
const PromoteAsAssociate = React.lazy(
  () =>
    import("../../../AssociatePanel/Pages/CustomerArea/PromoteAsAssociate/PromoteAsAssociate"),
);

const UserList = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("All");
  const [isCustomerAdd, setIsCustomer] = useState(false);
  const [promoteAsAssociate, setpromoteAsAssociate] = useState(false);

  // pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Data State
  const [customerData, setCustomerData] = useState([]);
  const navigate = useNavigate();
  const { sendApiRequest, loading: apiLoading } = useApiRequest();

  // --- API Call Logic ---
  const fetchCustomerList = useCallback(() => {
    // Map UI Tabs to API Filter strings if necessary
    // Example: "Active" -> "Y", "KYC Pending" -> "KYC_N", etc.
    const apiFilter = activeTab === "All" ? "" : activeTab;
    const payload = {
      Mode: "SELECT",
      Status: activeTab === "Active" ? "Y" : "",
      KycFilter: activeTab != "Active" ? apiFilter : "",
      SearchKey: searchTerm,
      CustomerType: selectedRole === "All" ? "" : selectedRole,
      pagesize: itemsPerPage,
      pageno: currentPage,
    };

    sendApiRequest("POST", "/CustomerArea/GetCustomerList", payload, {
      onSuccess: (res) => {
        const parsedData = res?.data?.jsondata
          ? JSON.parse(res?.data?.jsondata)
          : [];
        console.log(parsedData);
        setCustomerData(parsedData);
      },
      onStatus3: () => navigate("/login"),
    });
  }, [
    activeTab,
    searchTerm,
    selectedRole,
    currentPage,
    itemsPerPage,
    sendApiRequest,
    navigate,
  ]);
  // Trigger API call when any filter changes
  useEffect(() => {
    // Debounce search to avoid too many API calls while typing
    const delayDebounceFn = setTimeout(() => {
      fetchCustomerList();
    }, 400);

    return () => clearTimeout(delayDebounceFn);
  }, [activeTab, searchTerm, selectedRole, currentPage, itemsPerPage]);

  // --- Logic: Clear All Filters ---
  const handleClearAll = () => {
    setActiveTab("All");
    setSearchTerm("");
    setSelectedRole("All");
  };

  const isFilterActive =
    activeTab !== "All" || searchTerm !== "" || selectedRole !== "All";

  // --- Dynamic Tab Logic ---
  // Note: For real counts, your API should ideally return these counts.
  // If not, these will only reflect the current filtered set.

  const tabs = [
    { label: "All", color: "#3b82f6" },
    { label: "Active", color: "#e6f4ea" },
    { label: "KYC Pending", color: "#fff7e6" },
    { label: "Last 15 Days", color: "#fce8e6" },
    { label: "Last 30 Days", color: "#f1f3f4" },
  ];

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.titleArea}>
          <h1>Customer List</h1>
          <p className={styles.subTitle}>
            Manage and monitor your customer base
          </p>
        </div>
        <button
          className={styles.addButton}
          onClick={() => setIsCustomer(true)}
        >
          <MdAddCircleOutline className={styles.btnIcon} /> Add Customer
        </button>
      </header>

      {/* Sidebars */}
      {isCustomerAdd && (
        <Sidebar
          setIsFilter={() => setIsCustomer(false)}
          heading="Add New Customer"
        >
          <React.Suspense fallback={<div>Loading...</div>}>
            <BusinessAddCustomer />
          </React.Suspense>
        </Sidebar>
      )}

      {promoteAsAssociate && (
        <Sidebar setIsFilter={() => setpromoteAsAssociate(false)}>
          <React.Suspense fallback={<div>Loading...</div>}>
            <PromoteAsAssociate />
          </React.Suspense>
        </Sidebar>
      )}

      {/* Tabs Section */}
      <div className={styles.tabsContainer}>
        {tabs.map((tab) => (
          <button
            key={tab.label}
            className={`${styles.tab} ${activeTab === tab.label ? styles.activeTab : ""}`}
            style={
              activeTab === tab.label ? { borderBottomColor: tab.color } : {}
            }
            onClick={() => setActiveTab(tab.label)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Filters Section */}
      <div className={styles.filterBar}>
        <div className={styles.filterInputs}>
          <select
            className={styles.select}
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="All">All Customers</option>
            <option value="Y">Self Customer</option>
            <option value="N">Referral Customer</option>
          </select>

          <div className={styles.searchWrapper}>
            <input
              type="text"
              placeholder="Search by name, phone or email..."
              className={styles.searchInput}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Chips */}
      {isFilterActive && (
        <div className={styles.chipsContainer}>
          {activeTab !== "All" && (
            <div className={styles.chip}>
              Tab: {activeTab} <MdClose onClick={() => setActiveTab("All")} />
            </div>
          )}
          {selectedRole !== "All" && (
            <div className={styles.chip}>
              Type: {selectedRole === "Y" ? "Self" : "Referral"}{" "}
              <MdClose onClick={() => setSelectedRole("All")} />
            </div>
          )}
          {searchTerm && (
            <div className={styles.chip}>
              Search: "{searchTerm}"{" "}
              <MdClose onClick={() => setSearchTerm("")} />
            </div>
          )}
          <div
            className={`${styles.chip} ${styles.clearAllBtn}`}
            onClick={handleClearAll}
          >
            <MdFilterListOff /> Clear All
          </div>
        </div>
      )}

      {/* Table Section */}
      <Table
        users={customerData}
        loading={apiLoading}
        handlePromoteAsAssociate={() => setpromoteAsAssociate(true)}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
    </div>
  );
};

export default UserList;
